var map = {
	"./Apple.js": [
		58355
	],
	"./AppleWithExerciseBridge.js": [
		45092,
		92
	],
	"./BaseGame copy.js": [
		47119,
		119
	],
	"./BaseGame.js": [
		73208
	],
	"./Berry copy.js": [
		12882,
		739,
		718,
		305,
		882
	],
	"./Berry.js": [
		27795,
		739,
		718,
		305,
		795
	],
	"./Boxing.js": [
		1944,
		739,
		944
	],
	"./Camera.js": [
		70432
	],
	"./FadeMaterial.js": [
		78708,
		305,
		708
	],
	"./GameGUI.js": [
		44170
	],
	"./GameInit.js": [
		84027,
		27
	],
	"./Garden.js": [
		30214,
		739,
		718,
		305,
		214
	],
	"./Kick.js": [
		82061,
		718,
		704,
		61
	],
	"./NiceWater.js": [
		73975,
		975
	],
	"./ParticleSystem.js": [
		57820,
		820
	],
	"./PhysicsGame.js": [
		2868
	],
	"./PoseDetection.js": [
		75727
	],
	"./Potato.js": [
		68524,
		739,
		718,
		524
	],
	"./Row.js": [
		49199,
		739,
		718,
		305,
		199
	],
	"./Segmentation.js": [
		76609
	],
	"./Sky.js": [
		88450,
		739,
		718,
		305,
		450
	],
	"./Stomp.js": [
		38978,
		718,
		305,
		978
	],
	"./Tomato.js": [
		28281,
		739,
		281
	],
	"./gnome.js": [
		1155,
		739,
		155
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70770;
module.exports = webpackAsyncContext;